import { Center, Grid, Skeleton, Stack, VisuallyHidden } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

/** Squelette du formulaire de `OnboardingPage` affiché pendant le chargement initial. */
const OnboardingPageLoader = () => {
  const { t } = useTranslate();

  return (
    <Center mih="50vh">
      <Stack gap="md" w="100%" maw={1000} role="status" aria-busy="true">
        <VisuallyHidden>{t('onboarding.loading')}</VisuallyHidden>
        <Skeleton height={32} width="50%" aria-hidden="true" />
        <Skeleton height={16} width="70%" aria-hidden="true" />
        <Grid align="flex-end" aria-hidden="true">
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Stack gap={6}>
              <Skeleton height={14} width="40%" />
              <Skeleton height={36} />
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 7 }}>
            <Stack gap={6}>
              <Skeleton height={14} width="30%" />
              <Skeleton height={36} />
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 1 }}>
            <Skeleton height={34} width={34} ml="auto" />
          </Grid.Col>
        </Grid>
        <Skeleton height={36} width={200} aria-hidden="true" />
        <Skeleton height={36} mt="md" aria-hidden="true" />
      </Stack>
    </Center>
  );
};

export default OnboardingPageLoader;
